export default {
    baseStyle: {
        drawerContent: {
            maxWidth: {base: 'none', lg: '448px'},
            boxShadow: 'lg',
            borderRadius: 0,
            m: 0
        },
        drawerBody: {
            margin: 'auto',
            width: '100%',
            overflowY: {base: 'hidden'},
            padding: 0,
            height: '100vh',
            color: 'webTypo.textPrimary'
        }
    }
}
